<template>
  <users-table :view="view" :row-click-enabled="false"/>
</template>

<script>
import { mapState } from 'vuex'
import usersTable from './table'

export default {
  components: {
    usersTable
  },
  computed: {
    ...mapState('users', {
      view: '_archivedView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/users/banned.vue